import { EpisodeOfCare } from '@interfaces/episode-of-care.interface';
import { EpisodeOfCareComponent } from '@interfaces/episode-of-care-component.interface';

export class EpisodeOfCareTotals {
  public member: number = 0;
  public employer: number = 0;
  public total: number = 0;
  public incentive: number = 0;
  public incentives: { procedure: string; amount: number }[] = [];

  constructor(episode: EpisodeOfCare = {} as EpisodeOfCare) {
    this.tally(episode);
  }

  private tally?(episode: EpisodeOfCare): void {
    if (episode && episode.components && episode.components.length > 0) {
      episode.components.forEach((comp: EpisodeOfCareComponent) => {
        if (comp.provider) {
          if (comp.provider.cost && comp.provider.cost[0]) {
            const cost = comp.provider.cost[0].member_costs.average;
            this.member += cost.member_cost || 0;
            this.employer += cost.employer_cost || 0;
            this.total += cost.procedure_cost || 0;
            this.incentive += cost.incentive_amount || 0;
            if (cost.incentive_amount > 0) {
              this.incentives.push({
                procedure: comp.name,
                amount: cost.incentive_amount,
              });
            }
          } else if (comp.provider.copay) {
            // Office Visits will only have copay and no cost.
            this.member += comp.provider.copay || 0;
            this.total += comp.provider.copay || 0;
          }
        }
      });
    }
  }
}
